import React, { useState, useRef, useEffect, createRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import scrollToComponent from "react-scroll-to-component";
import { FormGroup, Nav, NavItem, NavLink, Col, Row } from "reactstrap";
// import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/header.js";
import Footer from "components/footers/footer.js";
import { FeatuersList } from "./FeaturesList.js";
import WebSitepage2 from "../images/features/Website-02.png";
import defaultCardImage from "../images/features/shield-icon.svg";
// import ThirdParty from "../images/features/ThirdParty.png";
import SocialMediaIntegration from "../images/features/SocialMediaIntegration.png";
import Vision from "../images/features/VisionAI.png"
import Enproject from "../images/features/Enproject.png"
import Lendezy from "../images/features/LendEzy.png"


const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-5 md:py-5`}
`;
const Heading = tw.h3`w-full text-left`;

// const VerticalSpacer = tw.div`mt-10 w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const HeroContainer = tw.div`relative mx-auto h-full flex flex-col`;

export default () => {
  const [activeTab, setActiveTab] = useState("1");

  const elementsRef = useRef(FeatuersList.map(() => createRef()));

  const toggle = (isActiveTab) => {
    setActiveTab(isActiveTab);
  };

  const handleScroll = () => {
    let wrapper = document.getElementById("wrapper"),
      main = document.getElementById("main"),
      sidebar = document.getElementById("sc");
    document
      .getElementById("sc")
      .setAttribute(
        "style",
        "display:block;width:" +
          document.getElementById("sidebar").offsetWidth +
          "px"
      );
    document.getElementById("sc").style.width =
      document.getElementById("sidebar").offsetWidth;
    //if sidebar smaller than main
    if (sidebar.offsetHeight < main.offsetHeight) {
      //if sidebar smaller than screen - stick to top rather than bottom
      if (sidebar.offsetHeight < window.innerHeight) {
        if (
          wrapper.getBoundingClientRect().bottom < window.innerHeight &&
          wrapper.getBoundingClientRect().bottom < sidebar.offsetHeight
        ) {
          wrapper.classList.remove("fix-top-VP");
          wrapper.classList.add("flex-bottom");
        } else if (wrapper.getBoundingClientRect().top < 0) {
          wrapper.classList.add("fix-top-VP");
          wrapper.classList.remove("flex-bottom");
        } else {
          wrapper.classList.remove("fix-top-VP");
          wrapper.classList.remove("flex-bottom");
        }
      }
      //if wrapper taller than sidebar - stick to bottom
      else if (sidebar.offsetHeight < wrapper.offsetHeight) {
        if (wrapper.getBoundingClientRect().bottom < window.innerHeight) {
          wrapper.classList.remove("fix-bottom-VP");
          wrapper.classList.add("flex-bottom");
        } else if (
          wrapper.getBoundingClientRect().bottom >
          sidebar.offsetHeight + window.innerHeight
        ) {
          wrapper.classList.remove("fix-bottom-VP");
          wrapper.classList.remove("flex-bottom");
        } else {
          wrapper.classList.add("fix-bottom-VP");
          wrapper.classList.remove("flex-bottom");
        }
      }
    }
  };

  useEffect(() => {
    // Anything in here is fired on component mount.
    window.addEventListener("scroll", handleScroll);
    return () => {
      // Anything in here is fired on component unmount.
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const changeActiveTab = (Tab) => {
    setActiveTab(Tab);
  };

  return (
    <div>
      <Header isActiveTab="2" />
      <Container>
        <HeroContainer>
          <img className="background_img" src={WebSitepage2} alt="background" />
          <FormGroup row className="backgoundtextfeatures">
            <Col md="7" sm="7" xs="7">
              <div>
                <h2 className="background_heading">
                  Features That Make Selling Easier
                </h2>
                <p className="background_paragraph">
                  Zinger provides powerful Integration with the most popular
                  platforms needed for the smooth functioning of your Jewellery
                  business.
                </p>
              </div>
            </Col>
          </FormGroup>
        </HeroContainer>
      </Container>
      <Container>
        <Row className="m-0 mt-4" id="wrapper">
          <Col
            sm="3"
            md="3"
            id="sidebar"
            className="sidebar p-0 d-none d-sm-block"
          >
            <Nav
              tabs
              vertical
              pills
              className="sidebar1 textandheader features-font-weight-bold"
              id="sc"
            >
              <NavItem>
                <NavLink
                  className={
                    activeTab === "1" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                   if (elementsRef.current[0]) {
                     elementsRef.current[0].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("1");
                  }}
                >
                  Real-time integration of HO & Branches <br/>
                  <small>(Multi-branch)</small>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "2" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[1]) {
                     elementsRef.current[1].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("2");
                  }}
                >
                  Estimation & Billing
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "3" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[2]) {
                     elementsRef.current[2].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("3");
                  }}
                >
                 Stock & RFID Inventory Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "4" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[3]) {
                     elementsRef.current[3].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("4");
                  }}
                >
                 Asset Tracking Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "5" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[4]) {
                     elementsRef.current[4].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("5");
                  }}
                >
                 Chit & Schemes Module
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "6" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[5]) {
                     elementsRef.current[5].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("6");
                  }}
                >
                 Dealer Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "7" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[6]) {
                     elementsRef.current[6].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("7");
                  }}
                >
                  Order Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "8" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[7]) {
                     elementsRef.current[7].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("8");
                  }}
                >
                  Repair Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "9" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[8]) {
                     elementsRef.current[8].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("9");
                  }}
                >
                  Karighar
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "10" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[9]) {
                     elementsRef.current[9].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("10");
                  }}
                >
                 Accounting
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "11" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[10]) {
                     elementsRef.current[10].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("11");
                  }}
                >
                 Staff (Sales) Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "12" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[11]) {
                     elementsRef.current[11].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("12");
                  }}
                >
                 Purchase Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "13" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[12]) {
                     elementsRef.current[12].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("13");
                  }}
                >
                  HR & Payroll Module
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "14" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[13]) {
                     elementsRef.current[13].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("14");
                  }}
                >
                  Non-Sale Stock Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "15" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[14]) {
                     elementsRef.current[14].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("15");
                  }}
                >
                  Customer Relationship Management & it's Analysis
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "16" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[15]) {
                     elementsRef.current[15].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("16");
                  }}
                >
                  Feedback Management & it's Analysis
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "17" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[16]) {
                     elementsRef.current[16].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("17");
                  }}
                >
                 Enquiry & Follow-up Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "18" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[17]) {
                     elementsRef.current[17].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("18");
                  }}
                >
                 Field Sales Management 
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "19" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[18]) {
                     elementsRef.current[18].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("19");
                  }}
                >
                  Location Tracking Module
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "20" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[19]) {
                     elementsRef.current[19].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("20");
                  }}
                >
                 Scheduled Reports & Notifications
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "21" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[20]) {
                     elementsRef.current[20].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("21");
                  }}
                >
                  User Entitlement Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "22" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[21]) {
                     elementsRef.current[21].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("22");
                  }}
                >
                  Track Critical Software Activity Logs
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "23" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[22]) {
                     elementsRef.current[22].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("23");
                  }}
                >
                  Loyalty & Reward Programs
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "24" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[23]) {
                     elementsRef.current[23].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("24");
                  }}
                >
                  Whatsapp / E-mail / SMS
                </NavLink>
              </NavItem>
               <NavItem>
                <NavLink
                  className={
                    activeTab === "25" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[24]) {
                     elementsRef.current[24].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("25");
                  }}
                >
                 AI Enabled Services
                </NavLink>
              </NavItem>
               <NavItem>
                <NavLink
                  className={
                    activeTab === "26" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[25]) {
                     elementsRef.current[25].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("26");
                  }}
                >
                 Appointment Management
                </NavLink>
              </NavItem>
               <NavItem>
                <NavLink
                  className={
                    activeTab === "27" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[26]) {
                     elementsRef.current[26].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("27");
                  }}
                >
                 Tech Wallet
                </NavLink>
              </NavItem>
               <NavItem>
                <NavLink
                  className={
                    activeTab === "28" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[27]) {
                     elementsRef.current[27].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("28");
                  }}
                >
                 Gold Loan Management
                </NavLink>
              </NavItem>
               <NavItem>
                <NavLink
                  className={
                    activeTab === "29" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[28]) {
                     elementsRef.current[28].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("29");
                  }}
                >
                 Performance Management
                </NavLink>
              </NavItem>
               <NavItem>
                <NavLink
                  className={
                    activeTab === "30" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[29]) {
                     elementsRef.current[29].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("30");
                  }}
                >
                 Goal Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "31" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[30]) {
                     elementsRef.current[30].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("31");
                  }}
                >
                  Third Party Software Integration
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "32" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[31]) {
                     elementsRef.current[31].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("32");
                  }}
                >
                   Third Party Hardware Integration
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "33" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[32]) {
                     elementsRef.current[32].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("33");
                  }}
                >
                  HUID (Hallmarking Unique Identification)
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "34" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[33]) {
                     elementsRef.current[33].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("34");
                  }}
                >
                Multi-Lingual & Multi-Currency Facility 
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "35" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[34]) {
                     elementsRef.current[34].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("35");
                  }}
                >
                  VR-Based Solution & Online Video
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "36" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[35]) {
                     elementsRef.current[35].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("36");
                  }}
                >
                    E-Commerce / E-Brochure Service
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "37" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[36]) {
                     elementsRef.current[36].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("37");
                  }}
                >
                Marketing 360<sup>0</sup> Solution
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "38" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[37]) {
                     elementsRef.current[37].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("38");
                  }}
                >
                  Online Payment Module Integration
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "39" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[38]) {
                     elementsRef.current[38].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("39");
                  }}
                >
                 Online Video Demo Module
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "40" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[39]) {
                     elementsRef.current[39].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("40");
                  }}
                >
                  MIS Reports
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "41" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[40]) {
                     elementsRef.current[40].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("41");
                  }}
                >
                  Mobile Apps (Android & IOS)
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "42" ? "feature_active_tab" : "feature_tab"
                  }
                  onClick={() => {
                    if (elementsRef.current[41]) {
                     elementsRef.current[41].scrollIntoView({
                       behavior: "smooth",
                       block: "start",
                     });
                   }
                    toggle("42");
                  }}
                >
                 Customizable Dashboard
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col xs="12" sm="9" md="9" id="main" className="sidebar_hide_xs">
            {FeatuersList.map((featureData, i) => (
              <div key={i}>
                <section
                  ref={(section) => {
                    elementsRef.current[i] = section;
                  }}
                >
                  <Container onMouseEnter={() => changeActiveTab(`${i + 1}`)}>
                    <ThreeColumnContainer>
                      <Heading className="textandheader animationRight text-center">
                        {featureData.name}
                      </Heading>
                      <span className="pb-3  text-center w-100">{featureData.describe}</span>
                {featureData.name === 'Online Payment Module Integration' ? 
                    <Column key={i} className="p-3 w-100">
                        <div className="tabcontent" data-aos="fade-left">
                            <Col md="12" xs="12" sm="12">
                                <img
                                  src={SocialMediaIntegration}
                                  alt="payment-gatway"
                                  
                                  className="tabcontent1 w-100"
                                />
                            </Col>
                        </div>
                      </Column> 
                      :
                      ''                    
                    }
                {featureData.name === 'AI Enabled Services' ? 
                    <Column key={i} className="p-3 w-100">
                        <div className="tabcontent" data-aos="fade-left">
                            <Col md="12" xs="12" sm="12">
                                <img
                                  src={Vision}
                                  alt="payment-gatway"
                                  
                                  className="tabcontent1 w-100"
                                />
                            </Col>
                        </div>
                      </Column> 
                      :
                      ''                    
                    }
                    {featureData.name === 'AI Enabled Services' ? 
                    <Column key={i} className="p-3 w-100">
                        <div className="tabcontent" data-aos="fade-left">
                            <Col md="12" xs="12" sm="12">
                                <img
                                  src={Enproject}
                                  alt="payment-gatway"
                                  
                                  className="tabcontent1 w-100"
                                />
                            </Col>
                        </div>
                      </Column> 
                      :
                      ''                    
                    }
                    {featureData.name === 'Gold Loan Management' ? 
                    <Column key={i} className="p-3 w-100">
                        <div className="tabcontent" data-aos="fade-left">
                            <Col md="12" xs="12" sm="12">
                                <img
                                  src={Lendezy}
                                  alt="payment-gatway"
                                  
                                  className="tabcontent1 w-100"
                                />
                            </Col>
                        </div>
                      </Column> 
                      :
                      ''                    
                    }

                    {featureData.data.map((item, i) => (
                        <Column key={i} className="p-3 w-100">
                        <div className="tabcontent" data-aos="fade-left">
                          <Row className="justify-content-center">
                            <Col md="4" xs="4" sm="4">
                              <div className="featureIcons">
                                <img
                                  src={item.imageSrc || defaultCardImage}
                                  alt={item.title}
                                  width="60px"
                                  className="tabcontent1"
                                />
                              </div>
                            </Col>
                          </Row>
                          <span>
                            <h4 className="text-center featureIcon font-weight-bold textandheader" style={{fontWeight: 'bold'}}>
                              <span className="title">{item.title}</span>
                            </h4>
                            {/* <p className="text-justify px-3 featureIcon textandheader">
                              <span className="title">
                                {item.description}
                              </span>
                            </p> */}
                          </span>
                        </div>
                      </Column>               
                      ))}
                    </ThreeColumnContainer>
                  </Container>
                </section>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};
